import React from 'react';
import Box from '@mui/material/Box';
import { Switch } from '@bloomays-lib/ui.shared';

import { dsV2 } from '@bloomays-lib/ui.shared';

export const SwitchRow = ({
  label,
  checked,
  onChange,
}: {
  label: React.ReactNode;
  checked: boolean;
  onChange: (v: boolean) => void;
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '12px',
      fontSize: 13,
      color: dsV2.color.t2,
    }}
  >
    <Switch size="small" checked={checked} onSwitch={(_e, value) => onChange(value)} />
    {label}
  </Box>
);
